import { fetcher } from '@src/utils/fetcher'
import type { Response } from '@src/utils/request'

// common code 获取方式
export async function getCommonCode(codeType?: string, searchKey?: string): Promise<Response> {
	return fetcher(`/common/code`, 'POST', { body: { searchKey: searchKey, codeType: codeType }, loading: false })
}

export async function getRolesCodeList(): Promise<Response> {
	return fetcher(`/common/code/role/list`, 'POST', { body: {}, loading: false })
}
export async function getDepthsCodeList(): Promise<Response> {
	return fetcher(`/common/code/dept/list`, 'POST', { body: {}, loading: false })
}
export async function getPermissionsCodeList(): Promise<Response> {
	return fetcher(`/common/code/permission/list`, 'POST', { body: {}, loading: false })
}

export async function getStudentCodeList(): Promise<Response> {
	return fetcher(`/common/code/student/list`, 'POST', { body: {}, loading: false })
}

export async function getClassesCodeList(): Promise<Response> {
	return fetcher(`/common/code/classes/list`, 'POST', { body: {}, loading: false })
}

export async function getClassesGroupCodeList(param: Record<string, any>): Promise<Response> {
	return fetcher(`/common/code/classes/group/list`, 'POST', { body: { searchParam: param }, loading: false })
}

// 查询 系统父目录菜单的下拉列表
export async function getMenuCodeList(): Promise<Response> {
	return fetcher(`/common/code/menu/list`, 'POST', { body: {}, loading: false })
}
